import {
  abortNewsletter,
  createHoliday,
  createNewsletter,
  deleteHoliday,
  deleteNewsletter,
  dispatchNewsletter,
  emailTemplates,
  getHolidays,
  getNewsletters,
  updateEmailTemplate,
  updateNewsletter
} from '../../../services/admin'

import {
  getUnModeratedAdverts,
  moderateAdvert,
  updateAdvert
} from '../../../services/adverts'

import {
  deleteOccupation,
  getOccupations,
  reassignOccupation,
  updateOccupation
} from '../../../services/resources'

import {
  deleteEmployerSearchOccupation,
  getUnModeratedEmployerSearchOccupations,
  updateEmployerSearchOccupation
} from '../../../services/stat'

import {
  getUnModeratedBidCards,
  moderateBidCard,
  updateBidCard
} from '../../../services/bid-cards'

import {
  deleteUser,
  searchUsers
} from '../../../services/users'

export default {
  getEmailTemplates ({ commit }) {
    return new Promise((resolve, reject) => {
      emailTemplates()
        .then(response => {
          const emailTemplates = response.data
          commit('setEmailTemplates', { emailTemplates })
          resolve(emailTemplates)
        })
        .catch(reject)
    })
  },

  updateEmailTemplate ({ commit }, { emailTemplate }) {
    return new Promise((resolve, reject) => {
      updateEmailTemplate(emailTemplate.id, {
        subject: emailTemplate.subject,
        description: emailTemplate.description,
        htmlBody: emailTemplate.htmlBody,
        senderName: emailTemplate.senderName,
        senderEmail: emailTemplate.senderEmail,
        replytoName: emailTemplate.replytoName,
        replytoEmail: emailTemplate.replytoEmail
      })
        .then(response => {
          const emailTemplate = response.data
          commit('updateEmailTemplate', {
            id: emailTemplate.id,
            emailTemplate
          })

          resolve(emailTemplate)
        })
        .catch(reject)
    })
  },

  getNewsletters ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getNewsletters(params)
        .then(response => {
          const newsletters = response.data
          commit('setNewsletters', { newsletters })
          resolve(newsletters)
        })
        .catch(reject)
    })
  },

  createNewsletter ({ commit }, newsletter) {
    return new Promise((resolve, reject) => {
      createNewsletter(newsletter)
        .then(response => {
          const newsletter = response.data
          commit('createNewsletter', { newsletter })
          resolve(newsletter)
        })
        .catch(reject)
    })
  },

  updateNewsletter ({ commit }, newsletter) {
    return new Promise((resolve, reject) => {
      updateNewsletter(newsletter.id, newsletter)
        .then(response => {
          const newsletter = response.data
          commit('updateNewsletter', { newsletter })
          resolve(newsletter)
        })
        .catch(reject)
    })
  },

  dispatchNewsletter ({ commit }, id) {
    return new Promise((resolve, reject) => {
      dispatchNewsletter(id)
        .then(() => {
          commit('dispatchNewsletter', id)
          resolve(true)
        })
        .catch(reject)
    })
  },

  abortNewsletter ({ commit }, id) {
    return new Promise((resolve, reject) => {
      abortNewsletter(id)
        .then(() => {
          commit('abortNewsletter', id)
          resolve(true)
        })
        .catch(reject)
    })
  },

  deleteNewsletter ({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteNewsletter(id)
        .then(() => {
          commit('deleteNewsletter', id)
          resolve(true)
        })
        .catch(reject)
    })
  },

  getHolidays ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getHolidays(params)
        .then(response => {
          const holidays = response.data
          commit('setHolidays', { holidays })
          resolve(holidays)
        })
        .catch(reject)
    })
  },

  createHoliday ({ commit }, { dates }) {
    return new Promise((resolve, reject) => {
      createHoliday({ dates })
        .then(response => {
          const [holiday] = response.data
          commit('createHoliday', { holiday })
          resolve(holiday)
        })
        .catch(reject)
    })
  },

  deleteHoliday ({ commit }, { dates }) {
    return new Promise((resolve, reject) => {
      deleteHoliday(dates)
        .then(() => {
          const [date] = dates
          commit('deleteHoliday', { date })
          resolve(true)
        })
        .catch(reject)
    })
  },

  searchUsers ({ commit }, { email }) {
    return new Promise((resolve, reject) => {
      searchUsers(email)
        .then(response => {
          const users = response.data
          commit('setUsers', { users })
          resolve(users)
        })
        .catch(reject)
    })
  },

  deleteUser ({ commit }, { id, reason }) {
    return new Promise((resolve, reject) => {
      deleteUser(id, reason)
        .then(() => {
          commit('deleteUser', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  getUnModeratedAdverts ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getUnModeratedAdverts(params)
        .then(response => {
          const adverts = response.data
          commit('setUnModeratedAdverts', { adverts })
          resolve(adverts)
        })
        .catch(reject)
    })
  },

  approveAdvert ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      updateAdvert(id, { moderated: true })
        .then(() => {
          commit('deleteUnModeratedAdvert', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  moderateAdvert ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      moderateAdvert(id)
        .then(() => {
          commit('deleteUnModeratedAdvert', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  flagAdvert ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      updateAdvert(id, { reqOversee: true })
        .then(() => {
          commit('flagAdvert', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  getUnModeratedBidCards ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getUnModeratedBidCards(params)
        .then(response => {
          const bidCards = response.data
          commit('setUnModeratedBidCards', { bidCards })
          resolve(bidCards)
        })
        .catch(reject)
    })
  },

  approveBidCard ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      updateBidCard(id, { moderated: true })
        .then(() => {
          commit('deleteUnModeratedBidCard', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  moderateBidCard ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      moderateBidCard(id)
        .then(() => {
          commit('deleteUnModeratedBidCard', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  flagBidCard ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      updateBidCard(id, { reqOversee: true })
        .then(() => {
          commit('flagBidCard', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  getUnModeratedEmployerSearches ({ commit }) {
    return new Promise((resolve, reject) => {
      getUnModeratedEmployerSearchOccupations()
        .then(response => {
          const searches = response.data.map(search => ({
            name: search.name,
            newName: search.name,
            count: search.count
          }))
          commit('setUnModeratedEmployerSearches', { searches })
          resolve(searches)
        })
        .catch(reject)
    })
  },

  moderateEmployerSearchOccupation ({ commit }, { name, data }) {
    return new Promise((resolve, reject) => {
      updateEmployerSearchOccupation(encodeURIComponent(name), data)
        .then(() => {
          commit('removeEmployerSearchOccupation', { name })
          resolve(true)
        })
        .catch(reject)
    })
  },

  deleteEmployerSearchOccupation ({ commit }, { name }) {
    return new Promise((resolve, reject) => {
      deleteEmployerSearchOccupation(encodeURIComponent(name))
        .then(() => {
          commit('removeEmployerSearchOccupation', { name })
          resolve(true)
        })
        .catch(reject)
    })
  },

  getUnModeratedOccupations ({ commit }) {
    return new Promise((resolve, reject) => {
      getOccupations({ moderated: false })
        .then(response => {
          const occupations = response.data
          commit('setUnModeratedOccupations', { occupations })
          resolve(occupations)
        })
        .catch(reject)
    })
  },

  moderateOccupation ({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      updateOccupation(id, data)
        .then(() => {
          commit('removeOccupation', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  reassignOccupation ({ commit }, { id, targetId }) {
    return new Promise((resolve, reject) => {
      reassignOccupation(id, targetId)
        .then(() => {
          commit('removeOccupation', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  deleteOccupation ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      deleteOccupation(id)
        .then(() => {
          commit('removeOccupation', { id })
          resolve(true)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/actions.js